module.exports = __webpack_public_path__ + "img/itembox.fc7ee2b2.png";